import LogDNA from 'helpers/logdna';
export const useLogger = () => {
    const logger = new LogDNA();
    return logger;
};
export default useLogger;
